module.exports = __webpack_public_path__ + "img/mic.ffc3fe24.svg";